/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Open_Rounds_DescInputs */



/**
* | output |
* | --- |
* | "non-VEKN house format; per-player round cap (details below)" |
*
* @param {Og_Cfg_Open_Rounds_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_open_rounds_desc = /** @type {((inputs?: Og_Cfg_Open_Rounds_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Open_Rounds_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("format maison non-VEKN ; limite de rondes par joueur (détails ci-dessous)")
	if (locale === "es") return /** @type {LocalizedString} */ ("formato casero no-VEKN; límite de rondas por jugador (detalles más abajo)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("formato caseiro não-VEKN; limite de rodadas por jogador (detalhes abaixo)")
	if (locale === "it") return /** @type {LocalizedString} */ ("formato casalingo non-VEKN; limite di round per giocatore (dettagli sotto)")
	return /** @type {LocalizedString} */ ("non-VEKN house format; per-player round cap (details below)")
});